import { Accordion as BaseAccordion } from "@flash-tecnologia/hros-web-ui-v2";
import styled, { keyframes } from "styled-components";

const bounceIn = keyframes`
  0% {
    opacity: 0;
    transform: scale3d(0.5, 0.5, 0.5);
  }
  30% {
    transform: scale3d(1.05, 1.05, 1.05);
  }
  50% {
    opacity: 1;
    transform: scale3d(0.95, 0.95, 0.95);
  }
  70% {
    transform: scale3d(1.02, 1.02, 1.02);
  }
  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
`;

export const Accordion = styled(BaseAccordion)<{ maxHeight?: number }>`
  & .MuiAccordionSummary-root {
    padding: ${({ theme }) => theme.spacings.xs2};
    padding-bottom: ${({ theme }) => theme.spacings.xs3};
  }

  & .MuiAccordionDetails-root {
    padding: ${({ theme }) => theme.spacings.xs2};
  }

  &.Mui-expanded {
    border-color: ${({ theme }) => theme.colors.neutral[90]};
    margin: unset;
  }

  ${({ maxHeight }) =>
    maxHeight !== undefined &&
    `
    & .MuiAccordionDetails-root {
      overflow: auto;
      max-height: ${maxHeight}px;
    }
  `}
`;

export const AnimatedAccordion = styled(Accordion)`
  animation: ${bounceIn} 1s ease both;

  & .MuiAccordionSummary-root {
    padding: ${({ theme }) => theme.spacings.xs2};
    padding-bottom: ${({ theme }) => theme.spacings.xs3};
  }

  & .MuiAccordionDetails-root {
    padding: ${({ theme }) => theme.spacings.xs2};
  }

  &.Mui-expanded {
    border-color: ${({ theme }) => theme.colors.neutral[90]};
    margin: unset;
  }
`;
